/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9348b4de (Tue Jan 13 18:25:19 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * All possible roles, categories, and filetypes for business content.
 * @export
 * @interface BusinessContentOptions
 */
export interface BusinessContentOptions {
  /**
   * All of the roles that business content can have.
   * @type {Array<string>}
   * @memberof BusinessContentOptions
   */
  roles: Array<string>
  /**
   * All of the categories that business content can have.
   * @type {Array<string>}
   * @memberof BusinessContentOptions
   */
  categories: Array<string>
  /**
   * All the filetypes that business content can be.
   * @type {Array<string>}
   * @memberof BusinessContentOptions
   */
  filetypes: Array<string>
}

export function BusinessContentOptionsFromJSON(
  json: any
): BusinessContentOptions {
  return BusinessContentOptionsFromJSONTyped(json, false)
}

export function BusinessContentOptionsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BusinessContentOptions {
  if (json === undefined || json === null) {
    return json
  }
  return {
    roles: json['roles'],
    categories: json['categories'],
    filetypes: json['filetypes'],
  }
}

export function BusinessContentOptionsToJSON(
  value?: BusinessContentOptions | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    roles: value.roles,
    categories: value.categories,
    filetypes: value.filetypes,
  }
}
